import { useState } from "react";
import { Trash } from "lucide-react";
import { handleErrMessage } from "../../../../functions/handleErrMessage";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import { DELETE_SITE_OPERATOR } from "../../../../api/allApi_List";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";

const splitDetails = (str) => {
  const [name, phone] = str.split(",").map((s) => s.trim());
  return { name, phone };
};

const SiteOperatorList = ({ operators, dataId, onDelete, deleteState }) => {
  const { isDeleting, isDeleteError, setIsDeleteError } = deleteState;
  const [currentDeleted, setCurrentDeleted] = useState(null);
  const { checkPermission } = UsePermissionsClaim();
  const permDeleteOperator = checkPermission("add_station_operator");

  const onSubmit = (operatorId) => {
    setCurrentDeleted(operatorId);
    //API calling
    onDelete(`${DELETE_SITE_OPERATOR}${dataId}/${operatorId}`);
  };

  return (
    <>
      {isDeleteError && (
        <ErrorDisplay
          message={handleErrMessage(isDeleteError)}
          closeAction={() => setIsDeleteError("")}
        />
      )}
      <div className={`px-4 pb-4 ${operators.length > 2 ? "h-40" : ""}`}>
        <table
          className={`remark-table ${operators.length > 2 ? "h-full" : ""}`}
        >
          <thead
            className={`remark-thead ${
              operators.length > 2 ? "w-99%" : "w-full"
            }`}
          >
            <th className="remarkTd">Name</th>
            <th className="remarkTd">Phone</th>
            {permDeleteOperator && <th className="remarkTd">Delete</th>}
          </thead>
          <tbody className="remark-tbody">
            {operators.map((ope, ind) => {
              const parts = splitDetails(ope);
              return (
                <tr key={ind} className="remark-tr">
                  <td className="remarkTd">{parts.name}</td>
                  <td className="remarkTd">{parts.phone}</td>
                  {permDeleteOperator && (
                    <td className="remarkTd text-red-600">
                      {isDeleting && currentDeleted === ind ? (
                        "Deleting..."
                      ) : (
                        <Trash
                          className="mx-auto cursor-pointer"
                          size={20}
                          onClick={() => onSubmit(ind)}
                        />
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default SiteOperatorList;
